import { render, staticRenderFns } from "./subjectResearchDetail.vue?vue&type=template&id=70d0f5b4&scoped=true&"
import script from "./subjectResearchDetail.vue?vue&type=script&lang=js&"
export * from "./subjectResearchDetail.vue?vue&type=script&lang=js&"
import style0 from "./subjectResearchDetail.vue?vue&type=style&index=0&id=70d0f5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d0f5b4",
  null
  
)

export default component.exports